// Image configuration for the application
export const images = {
  // Logo images
  logo: '/smplogo.png',
  logoAlt: '/logo.png',
  logo1: '/logo1.png',
  multicare: '/multicare.png',
  
  // Mascot images
  penguin: 'https://res.cloudinary.com/dp91jhj84/image/upload/v1755015328/penguin_gqoggm.png',
  
  // Background images
  vote: '/assets/vote.png',
  voting: '/assets/voting.png',
  
  // Product images (for reference)
  products: {
    abbottsurbex: '/abbottsurbex.png',
    absorbaconti: '/absorbaconti.png',
    alphag: '/alphag.png',
    appetonwellness: '/appetonwellness.png',
    avosoda: '/avosoda.png',
    axeoil: '/axeoil.png',
    biogreen5: '/biogreen5.png',
    biolife: '/biolife.png',
    biolifeevening: '/biolifeevening.png',
    biolifevita: '/biolifevita.png',
    bioquinone: '/bioquinone.png',
    blackmorecalcium: '/blackmorecalcium.png',
    blackmored3: '/blackmored3.png',
    blackmoregluco: '/blackmoregluco.png',
    blackmoreq10: '/blackmoreq10.png',
    blackmoresbioe: '/blackmoresbioe.png',
    ceradangentle: '/ceradangentle.png',
    certaintydrypants: '/certaintydrypants.png',
    cetaphilintensive: '/cetaphilintensive.png',
    champsvitaminc: '/champsvitaminc.png',
    clearogout: '/clearogout.png',
    drpbasic: '/drpbasic.png',
    duphalac: '/duphalac.png',
    duplex: '/duplex.png',
    egoqv: '/egoqv.png',
    eldonomega3: '/eldonomega3.png',
    enercalcomplete: '/enercalcomplete.png',
    ensure: '/ensure.png',
    ensureplant: '/ensureplant.png',
    epsomsalt: '/epsomsalt.png',
    ezerraextra: '/ezerraextra.png',
    forlax: '/forlax.png',
    glukusking: '/glukusking.png',
    gsure: '/gsure.png',
    guardplus: '/guardplus.png',
    happygrains: '/happygrains.png',
    heihwang: '/heihwang.png',
    hennsondrycomfort: '/hennsondrycomfort.png',
    hurixnoto: '/hurixnoto.png',
    hydrocyn: '/hydrocyn.png',
    kingcare: '/kingcare.png',
    kmitsusuperfood: '/kmitsusuperfood.png',
    kordelgluco: '/kordelgluco.png',
    kotexovernight: '/kotexovernight.png',
    kwanloong: '/kwanloong.png',
    lactulsolution: '/lactulsolution.png',
    lauriernightsafe: '/lauriernightsafe.png',
    libresses: '/libresses.png',
    livewellsoria: '/livewellsoria.png',
    mircrolifeblood: '/mircrolifeblood.png',
    mobithorn: '/mobithorn.png',
    multicare: '/multicare.png',
    naturalclenx: '/naturalclenx.png',
    nhdarkchoc: '/nhdarkchoc.png',
    nhdetoxlim: '/nhdetoxlim.png',
    omron: '/omron.png',
    osteoactiv: '/osteoactiv.png',
    penguin: '/penguin.png',
    pharmaniaga: '/pharmaniaga.png',
    redoxonkids: '/redoxonkids.png',
    rossmaxblood: '/rossmaxblood.png',
    smp: '/smp.png',
    stayfreemaxi: '/stayfreemaxi.png',
    tena: '/tena.png',
    tenasuperlong: '/tenasuperlong.png',
    tocovid: '/tocovid.png',
    uliteorange: '/uliteorange.png',
    uphalyte: '/uphalyte.png',
    ural: '/ural.png',
    viatril: '/viatril.png',
    vitahealthk2: '/vitahealthk2.png',
    vitahealthvitamine: '/vitahealthvitamine.png',
    vitamode: '/vitamode.png',
    vitamodek2: '/vitamodek2.png',
    vitamodekids: '/vitamodekids.png',
    vylex: '/vylex.png',
    yuyeeoil: '/yuyeeoil.png'
  }
};

// Helper function to get responsive image URLs
export const getResponsiveImageUrl = (baseUrl, width) => {
  if (baseUrl.includes('cloudinary.com')) {
    return baseUrl.replace('/upload/', `/upload/w_${width},c_scale/`);
  }
  return baseUrl;
};

// Helper function to get optimized image URL
export const getOptimizedImageUrl = (imagePath, width = 400) => {
  if (imagePath.includes('cloudinary.com')) {
    return getResponsiveImageUrl(imagePath, width);
  }
  return imagePath;
};





